<template>
    <div>
        <Head :title="__('Close Ticket')" />

        <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
            <div class="flex justify-between items-center mb-6">
                <h1 class="text-2xl font-bold text-gray-900">
                    {{ __('Close Ticket #') }}{{ ticket.uid }}
                </h1>
                <Link :href="route('tickets.edit', ticket.id)" class="btn-indigo">
                    {{ __('Back to Ticket') }}
                </Link>
            </div>

            <div class="bg-white shadow overflow-hidden sm:rounded-lg">
                <div class="px-4 py-5 sm:px-6 border-b border-gray-200">
                    <h3 class="text-lg leading-6 font-medium text-gray-900">
                        {{ ticket.subject }}
                    </h3>
                    <p class="mt-1 max-w-2xl text-sm text-gray-500">
                        {{ __('Created') }}: {{ formatDate(ticket.created_at) }}
                        <span v-if="ticket.closed_at" class="ml-4">
                            {{ __('Closed') }}: {{ formatDate(ticket.closed_at) }}
                        </span>
                    </p>
                </div>

                <div class="bg-white shadow overflow-hidden sm:rounded-lg mt-6 p-6">
                    <button @click="openCloseTicketModal" class="btn-red">
                        {{ ticket.closed_at ? __('Update Resolution') : __('Close Ticket') }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Close Ticket Modal -->
        <Modal :show="showCloseTicketModal" @close="closeCloseTicketModal" max-width="md">
            <div class="p-6">
                <h2 class="text-lg font-medium text-gray-900 mb-4">
                    {{ ticket.closed_at ? __('Update Resolution') : __('Close Ticket') }}
                </h2>

                <textarea-input v-model="closeForm.resolution" :error="closeForm.errors.resolution"
                    class="pb-4 w-full" :label="__('Resolution Details')" />

                <div class="flex justify-end mt-6 space-x-2">
                    <button type="button" @click="closeCloseTicketModal" class="btn-gray">
                        {{ __('Cancel') }}
                    </button>
                    <LoadingButton @click="closeTicket" :loading="closingTicket" class="btn-red">
                        {{ closingTicket ? __('Processing...') : (ticket.closed_at ? __('Update') : __('Close Ticket')) }}
                    </LoadingButton>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Shared/Layout';
import Modal from '@/Shared/Modal';
import TextareaInput from '@/Shared/TextareaInput';
import LoadingButton from '@/Shared/LoadingButton';

export default {
    components: {
        Head,
        Link,
        Modal,
        TextareaInput,
        LoadingButton
    },
    layout: Layout,
    props: {
        ticket: Object,
    },
    data() {
        return {
            showCloseTicketModal: false,
            closingTicket: false,
            closeForm: this.$inertia.form({
                resolution: this.ticket.resolution || '',
            })
        }
    },
    methods: {
        formatDate(date) {
            return new Date(date).toLocaleString();
        },
        openCloseTicketModal() {
            this.showCloseTicketModal = true;
        },
        closeCloseTicketModal() {
            this.showCloseTicketModal = false;
        },
        closeTicket() {
            this.closingTicket = true;
            this.closeForm.put(route('tickets.close', this.ticket.id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.closeCloseTicketModal();
                    this.closingTicket = false;
                },
                onError: () => {
                    this.closingTicket = false;
                }
            });
        }
    }
}
</script>
